import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { StoreModule } from '@ngrx/store';
import { reducers, metaReducers } from 'src/store';
import { EffectsModule } from '@ngrx/effects';
import { WorkspaceEffects } from 'src/store/workspace';
import { MsAdalAngular6Module, MsAdalAngular6Service, AuthenticationGuard } from 'microsoft-adal-angular6';
import { environment } from 'src/environments/environment';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { HttpClientModule } from '@angular/common/http';
import { AuthInterceptor } from './interceptor/auth.interceptor';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { ToolBarModule } from '@progress/kendo-angular-toolbar';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { WorkspaceComponent } from './components/workspace/workspace.component';
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';
import { ToolbarSelectComponent } from './common/toolbar-select/toolbar-select.component';
import { ToolbarDatePickerComponent } from './common/toolbar-date-picker/toolbar-date-picker.component';
import { DateInputsModule } from '@progress/kendo-angular-dateinputs';
import { PopupModule } from '@progress/kendo-angular-popup';
import { GridModule } from '@progress/kendo-angular-grid';
import { ButtonsModule } from '@progress/kendo-angular-buttons';
import { TimesheetDetailComponent } from './components/timesheet-detail/timesheet-detail.component';
import { SearchbarComponent } from './components/searchbar/searchbar.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { InputsModule } from '@progress/kendo-angular-inputs';
import { AlertComponent } from './components/alert/alert.component';
import { TimesheetSummaryComponent } from './components/timesheet-summary/timesheet-summary.component';
import { DialogsModule } from '@progress/kendo-angular-dialog';
import { SelectPayperiodComponent } from './components/select-payperiod/select-payperiod.component';
import { ContextMenuModule } from '@progress/kendo-angular-menu';
import { TooltipModule } from '@progress/kendo-angular-tooltip';
import { ValidationTooltipComponent } from './common/validation-tooltip/validation-tooltip.component';
import { CategoriesComponent } from './components/categories/categories.component';
import { DescriptionsComponent } from './components/descriptions/descriptions.component';
import { StaffComponent } from './components/staff/staff.component';
import { ClientComponent } from './components/clients/client.component';
import { PaidTimeOffComponent } from './components/paid-time-off/paidTimeOff.component';



 // <== add the imports!

export function msAdalAngular6ConfigFactory() {
  return environment.adalConfig; // will be invoked later when creating MsAdalAngular6Service
}

@NgModule({
  declarations: [
    AppComponent,
    WorkspaceComponent,
    ToolbarSelectComponent,
    ToolbarDatePickerComponent,
    TimesheetDetailComponent,
    SearchbarComponent,
    AlertComponent,
    TimesheetSummaryComponent,
    SelectPayperiodComponent,
    ValidationTooltipComponent,
    CategoriesComponent,
    DescriptionsComponent,
    StaffComponent,
    ClientComponent,
    PaidTimeOffComponent
  ],
  imports: [
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    AppRoutingModule,
    HttpClientModule,
    MsAdalAngular6Module,
    EffectsModule.forRoot([WorkspaceEffects]),
    StoreModule.forRoot(reducers, {
      metaReducers,
      runtimeChecks: {
        strictStateImmutability: true,
        strictActionImmutability: true
      }
    }),
    !environment.production ? StoreDevtoolsModule.instrument() : [],
    StoreDevtoolsModule.instrument({ maxAge: 25, logOnly: environment.production }),
    ToolBarModule,
    BrowserAnimationsModule,
    DropDownsModule,
    DateInputsModule,
    PopupModule,
    GridModule,
    ButtonsModule,
    InputsModule,
    DialogsModule,
    ContextMenuModule,
    TooltipModule
  ],
  providers: [
    MsAdalAngular6Service,
    {
      provide: 'adalConfig',
      useFactory: msAdalAngular6ConfigFactory,
      deps: []
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true
    },
    AuthenticationGuard
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
